import React from 'react';
type FieldDiamondProps = {
  className?: string;
  strokeWidth?: number;
};

/**
 * Diamante de béisbol visto desde arriba, dibujado en tiza — el motivo
 * de portada del producto (tomos DPS-30). Hereda el color via
 * `currentColor`; el tamaño y la opacidad se setean en el elemento.
 */
export function FieldDiamond({
  className,
  strokeWidth = 3
}: FieldDiamondProps) {
  return <svg viewBox="0 0 240 230" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className} data-id="element-108" data-mp="1pzncov01qf6g">
      {/* outfield fence arc (dashed chalk) */}
      <path d="M26 158 A 104 104 0 0 1 214 158" strokeDasharray="2 10" opacity="0.85" data-id="element-109" data-mp="1g3kchuor8qm5" />
      {/* foul lines from home */}
      <path d="M120 196 L26 150" data-id="element-110" data-mp="3aeqqimxdpqsa" />
      <path d="M120 196 L214 150" data-id="element-111" data-mp="3adnz8dw59mbu" />
      {/* infield diamond */}
      <path d="M120 196 L176 140 L120 84 L64 140 Z" data-id="element-112" data-mp="36f81pg2fsvk6" />
      {/* bases */}
      <rect x="171" y="135" width="10" height="10" rx="2" transform="rotate(45 176 140)" fill="currentColor" stroke="none" data-id="element-113" data-mp="29kgs6sxztkt" />
      <rect x="115" y="79" width="10" height="10" rx="2" transform="rotate(45 120 84)" fill="currentColor" stroke="none" data-id="element-114" data-mp="3pf32qt2efv7y" />
      <rect x="59" y="135" width="10" height="10" rx="2" transform="rotate(45 64 140)" fill="currentColor" stroke="none" data-id="element-115" data-mp="l0v46dzglo7y" />
      {/* home plate */}
      <path d="M114 191 h12 v6 l-6 6 l-6 -6 Z" fill="currentColor" stroke="none" data-id="element-116" data-mp="c92yegldr39p" />
      {/* pitcher's mound */}
      <circle cx="120" cy="140" r="6" fill="currentColor" stroke="none" data-id="element-117" data-mp="g8tloabp719h" />
    </svg>;
}